/**
 * Get place details by place_id using PlacesService (no Geocoding API).
 * Uses only the Places library loaded with the Maps JS API.
 * @param {string} placeId - Google Place ID from Autocomplete
 * @returns {Promise<{ lat: number, lng: number, fullAddress: string, city: string }|null>}
 */
export function getPlaceDetailsByPlaceId(placeId) {
  return new Promise((resolve) => {
    if (!placeId || typeof placeId !== "string") {
      return resolve(null)
    }

    const google = window?.google
    if (!google?.maps?.places?.PlacesService) {
      return resolve(null)
    }

    // PlacesService requires a Map or HTMLDivElement
    let div = document.getElementById("places-service-attachment")
    if (!div) {
      div = document.createElement("div")
      div.id = "places-service-attachment"
      div.setAttribute("aria-hidden", "true")
      div.style.cssText = "position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;"
      document.body.appendChild(div)
    }

    const service = new google.maps.places.PlacesService(div)
    const request = {
      placeId,
      fields: ["geometry", "formatted_address", "address_components"],
    }

    service.getDetails(request, (place, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK || !place) {
        return resolve(null)
      }

      const lat = place.geometry?.location?.lat?.()
      const lng = place.geometry?.location?.lng?.()
      const fullAddress = place.formatted_address || ""

      let city = ""
      const components = place.address_components || []
      const locality = components.find((c) => c.types && c.types.includes("locality"))
      const admin2 = components.find((c) => c.types && c.types.includes("administrative_area_level_2"))
      city = (locality && locality.long_name) || (admin2 && admin2.long_name) || ""

      if (lat == null || lng == null) {
        return resolve(null)
      }

      resolve({
        lat: Number(lat),
        lng: Number(lng),
        fullAddress,
        city,
      })
    })
  })
}
